import { StepsProps as AntdStepsProps } from "antd/lib/steps";

export type StepListType = { title?: string, description?: string }[]

export type StepsProps = AntdStepsProps & {
	stepList: StepListType
	currentStepIcon?: React.ReactNode
};

export type DefaultStepsProps = {
	stepList: NonNullable<(StepsProps['stepList'])>
};

export const defaultProps: DefaultStepsProps = {
	stepList: [],
};
